import { render, staticRenderFns } from "./TopEntityComponentCountRoutes.vue?vue&type=template&id=d9ffa23c&"
import script from "./TopEntityComponentCountRoutes.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentCountRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports